import { useTranslation } from "react-i18next";

const NETWORK_SITES = [
  // Active sports calendar network. The five flagship European league sites
  // (bundesligacalendar.com, laligacalendar.com, ligue1calendar.com,
  // plcalendar.com, serieacalendar.com) have been consolidated into
  // worldgamecal.com and 301-redirect there. They must not appear here.
  { name: "Formula Calendar", domain: "formulacal.com", desc: "F1, F2, F3, Formula E, IndyCar schedule" },
  { name: "World Cup 2026 Calendar", domain: "wccalendar.com", desc: "FIFA World Cup 2026 match schedule" },
  { name: "World Game Calendar", domain: "worldgamecal.com", desc: "Premier League, La Liga, Bundesliga, Ligue 1 & Serie A 2025/26" },
  { name: "Champions League Calendar", domain: "uclcalendar.com", desc: "UEFA Champions League 2025/26 fixtures" },
  { name: "AFL Calendar", domain: "aflcalendar.com", desc: "AFL 2026 season fixtures" },
];

const CURRENT_DOMAIN = "formulacal.com";

export default function MegaFooter() {
  const { t } = useTranslation();
  return (
    <nav aria-label="Sports Calendar Network" className="border-t border-border/20 mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        {/* Heading — centred */}
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-8 text-center" style={{ maxWidth: 'none' }}>
          {t("footer.network_heading")}
        </p>

        {/* Site grid — 2 cols mobile, 3 cols tablet, 5 cols desktop, centred within container */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
            {NETWORK_SITES.map((site) => {
              const isCurrent = site.domain === CURRENT_DOMAIN;
              return (
                <a
                  key={site.domain}
                  href={isCurrent ? "/" : `https://${site.domain}`}
                  onClick={
                    isCurrent
                      ? (e: React.MouseEvent) => {
                          e.preventDefault();
                          window.location.href = "/";
                          window.scrollTo(0, 0);
                        }
                      : undefined
                  }
                  className={`
                    group block rounded-lg border px-4 py-3 transition-all
                    ${isCurrent
                      ? "border-primary/25 bg-primary/[0.04]"
                      : "border-transparent hover:border-border/30 hover:bg-muted/30"
                    }
                  `}
                  {...(!isCurrent
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                >
                  <span
                    className={`block text-[13px] font-medium leading-snug ${
                      isCurrent
                        ? "text-primary"
                        : "text-foreground/70 group-hover:text-foreground transition-colors"
                    }`}
                  >
                    {site.name}
                  </span>
                  <span className="block text-[11px] text-muted-foreground/80 mt-1 leading-snug">
                    {site.desc}
                  </span>
                </a>
              );
            })}
          </div>
        </div>

        {/* Attribution — centred */}
        <div className="mt-10 text-center">
          <p className="text-[11px] text-muted-foreground leading-relaxed" style={{ maxWidth: 'none' }}>
            {t("footer.network_tagline")}
          </p>

        </div>
      </div>
    </nav>
  );
}
